<script lang="ts" setup>
const { LocalConfigurationStore } = stores()
const heading = computed(() => LocalConfigurationStore.value?.highlights?.section)
const highlightsInfo = LocalConfigurationStore?.value?.highlights
</script>

<template>
  <div class="flex flex-col gap-1">
    <TitleComponent
      v-if="heading"
      :text="heading.title"
      :tagline="heading?.subTitle"
    />
    <div class="flex flex-wrap justify-center gap-12">
      <GridComponent
        v-if="highlightsInfo?.items?.length"
        :cols="highlightsInfo?.items.length"
        :min-cols="highlightsInfo.items.length % 2 === 0 ? 2 : 1"
      >
        <template
          v-for="(highlight, i) in highlightsInfo?.items"
          :key="i"
        >
          <CardComponent :layout="$viewport.isGreaterOrEquals('md') ? 'vertical' : 'horizontal'">
            <template #header>
              <div class="md:hidden flex items-center justify-center">
                <span
                  v-if="highlight.icon"
                  :class="getIconClass(highlight.icon)"
                  class="text-white text-4xl md:text-5xl"
                />
              </div>
              <span class="hidden md:block text-sm font-bold uppercase md:text-lg">
                {{ highlight.title }}
              </span>
            </template>

            <div class="flex md:flex-col w-full items-center gap-3 md:gap-4 p-3 md:p-4">
              <div class="md:flex items-center justify-center hidden">
                <span
                  v-if="highlight.icon"
                  :class="getIconClass(highlight.icon)"
                  class="accent text-primary text-4xl md:text-5xl"
                />
              </div>
              <div>
                <span class="block md:hidden text-sm font-bold uppercase md:text-lg">
                  {{ highlight.title }}
                </span>
                <div class="text-xs md:text-sm md:text-center leading-tight">
                  {{ highlight.description }}
                </div>
              </div>
            </div>
          </CardComponent>
        </template>
      </GridComponent>
    </div>
  </div>
</template>
